export default __webpack_public_path__ + "static/media/13.96a4286b.webp";